import React from 'react';
import { Link } from 'react-router-dom';
import Bullet from 'components/prism/bullet';
import { SystemText } from '@salesperformanceint/e4shared';

export const ObjectiveSummary = ({ objective, padBottom }) => {
    return (
        <Link
            to={`/objectives/${objective.profile_Id}/objective/${objective.id}`}
            data-testid="objective-item"
            className={`prism-content-box anchor-top ${padBottom ? 'mb10' : ''}`}
        >
            <div className="prism-content">
                <Bullet type="objective" subType={objective.type} size="lg" />
                <h3>{objective.name}</h3>
                {objective?.description && <p className="truncate-4">{objective.description}</p>}
                <Bullet value={SystemText('Controls/CompletedObjective/Approved')} icon="badge-check" style="success" />
            </div>
        </Link>
    );
};

export default ObjectiveSummary;
